import React from "react";
import "./MindfulnessMusicBar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlay,
  faPause,
  faVolumeHigh,
  faVolumeXmark,
  faMusic,
  faArrowUpRightFromSquare,
} from "@fortawesome/free-solid-svg-icons";
import { useMindfulnessMusic } from "../../../context/MindfulnessMusicContext";

export const MindfulnessMusicBar = ({ className = "" }) => {
  const {
    isMusicPlaying,
    toggleMusic,
    isMuted,
    toggleMute,
    volume,
    setVolume,
  } = useMindfulnessMusic();

  return (
    <div
      className={`mindfulness-music-bar ${
        isMusicPlaying ? "playing" : ""
      } ${className}`}
    >
      <div className="music-bar-left">
        <button
          type="button"
          className={`music-play-btn ${isMusicPlaying ? "active" : ""}`}
          onClick={toggleMusic}
          title={
            isMusicPlaying
              ? "Pause background music"
              : "Play soothing background music"
          }
          aria-label={
            isMusicPlaying
              ? "Pause background music"
              : "Play soothing background music"
          }
        >
          <FontAwesomeIcon icon={isMusicPlaying ? faPause : faPlay} />
        </button>
        <div className="music-info">
          <div className="music-title-row">
            <FontAwesomeIcon icon={faMusic} className="music-note-icon" />
            <span className="music-title">Mindfulness Background Music</span>
            {isMusicPlaying ? (
              <span className="music-live-badge active">
                <span className="sound-wave wave-1"></span>
                <span className="sound-wave wave-2"></span>
                <span className="sound-wave wave-3"></span>
                Playing
              </span>
            ) : (
              <span className="music-live-badge paused">Paused</span>
            )}
            <a
              href="https://indiemusicbox.com"
              target="_blank"
              rel="noopener noreferrer"
              className="music-courtesy-pill"
              title="Visit artist website: Chris Collins (Indie Music Box)"
            >
              <span>Courtesy of Chris Collins</span>
              <FontAwesomeIcon
                icon={faArrowUpRightFromSquare}
                className="music-courtesy-icon"
              />
            </a>
          </div>
          <p className="music-subtitle">
            "Wavelengths – Alpha" by Chris Collins · Calming ambient soundscape with alpha waves
          </p>
        </div>
      </div>

      <div className="music-bar-right">
        <button
          type="button"
          className="music-mute-btn"
          onClick={toggleMute}
          title={isMuted ? "Unmute" : "Mute"}
          aria-label={isMuted ? "Unmute" : "Mute"}
        >
          <FontAwesomeIcon
            icon={isMuted || volume === 0 ? faVolumeXmark : faVolumeHigh}
          />
        </button>
        <input
          type="range"
          min="0"
          max="1"
          step="0.05"
          value={isMuted ? 0 : volume}
          onChange={(e) => setVolume(parseFloat(e.target.value))}
          className="music-volume-slider"
          title={`Volume: ${Math.round((isMuted ? 0 : volume) * 100)}%`}
          aria-label="Background music volume"
        />
      </div>
    </div>
  );
};
